module.exports = __webpack_public_path__ + "img/alertWardInfoRed.7ec4e3d5.svg";